<template>
  <v-container fluid>
    <div class="pa-3" style="font-size:10px;">ADMIN > BusienssListNew</div>
    <v-row align="start" justify="center">
      <v-col cols="12" sm="12" md="12" class="pb-0">
        <v-card class="elevation-4">
          <v-card-title>
            <div class="btitle">BUSINESS</div>
            <div class="flex-grow-1"></div>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-btn color="primary" class="ml-3" @click="$router.push('/agent/createbusiness')">Create Business</v-btn>
          </v-card-title>

          <v-overlay v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-card-text>
            <v-divider></v-divider>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row align="start" justify="center">
      <v-col cols="12" sm="8" md="10" class="pt-0">
        <v-card class="elevation-4">
          <v-card-title>
            <div class="sort">Sorted By:</div>

          </v-card-title>

        </v-card>
      </v-col>
    </v-row> -->


    <!-- Mobile View -->


    <v-row align="center" justify="center" class="d-md-none d-sm-none">
                <v-col cols="12" sm="12" md="12">
                    <v-card class="elevation-4" v-for="busines in businesses">
                        <v-card class="mb-2 bu-maker" @click="bDetail(busines.id)" :data-id="busines.id">
                            <v-card-text>
                              <v-row align="start" justify="center" class="bdr p-5">
                                  <v-col cols="8" sm="4" md="4" align="left" justify="left" class="">
                                      <div class="bsubtitle">{{ busines.businessName }}</div>
                                      <div class="txt_color">{{ busines.businessType  }}</div>
                                      <div class="sCity sAddress">{{ busines.addressLine1 }} {{ busines.addressLine2 }}</div>
                                      <div class="sCity">{{ busines.addressLine3  }} {{ busines.addressLine4 }} {{ busines.addressLine5 }} </div>
                                  </v-col>

                                  <v-col cols="4" sm="5" md="5" class="text-center verticalLine p-5">
                                    <div class="tag-assign"  :style="{ backgroundImage: `url('${tagIMG} ')`}"> {{ busines.tagsassigned }} </div>
                                    <!-- <div class="tag-assign"  :style="{ backgroundImage: `url('${tagIMG} ')`, height:'85px' }"> {{ busines.tagsassigned }} </div> -->
                                      <!-- <v-img :src="tagIMG" width="65" height="65" class="text-center"></v-img> -->
                                  </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12" sm="12" md="12" class="text-right ">

                                  <v-btn @click="addFoodItem(busines.id)" color="primary "  fab x-small dark class="mr-2" title="Add Food Item">
                                    <v-icon>mdi-food</v-icon>
                                  </v-btn>
                                  <v-btn @click="addEmployee(busines.id)" color="primary "  fab x-small dark class="mr-2" title="Add Employee">
                                    <v-icon>mdi-account-tie</v-icon>
                                  </v-btn>
                                  <v-btn @click="addDepartment(busines.id)" color="primary "  fab x-small dark class="mr-2" title="Add Department">
                                    <v-icon>mdi-desktop-mac</v-icon>
                                  </v-btn>
                                  <v-btn @click="addEvent(busines.id)" color="primary " fab x-small dark class="mr-0" title="Add Event">
                                    <v-icon>mdi-calendar-plus</v-icon>
                                  </v-btn>
                                  <v-btn @click="editItem(busines.id)" color="primary " fab x-small dark class="mr-2">
                                    <v-icon>mdi-pencil</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>


                              <v-row align="center" justify="center" v-bind:class="{ 'd-flex': currentBusiness==busines.id,'d-none':currentBusiness!=busines.id }"  :id="busines.id">
                                  <v-col cols="8" sm="7" md="7" align="left" justify="center">
                                      <div class="bsubtitle">{{ busines.contactName }}</div>
                                      <div class="txt_color">{{ busines.contactPosition  }}</div>
                                      <div class="fs-10">Employees:{{ busines.employees }}</div>

                                  </v-col>

                                  <v-col cols="4" sm="5" md="5" class="text-center verticalLine p-5 " >

                                      <v-img :src="tagIMG" width="65" height="65" class="text-center ml-20" contain="true"></v-img>
                                  </v-col>
                              </v-row>
                              <v-divider></v-divider>

                              <v-row align="center" justify="center" v-bind:class="{ 'd-flex': currentBusiness==busines.id,'d-none':currentBusiness!=busines.id }"  :id="busines.id">
                                  <v-col cols="3" sm="4" md="4" align="left" justify="center">

                                        <!-- <a :href="'tel:'+busines.agent.mobile" class="txtblck"><v-img :src="phoneIMG" width="27" height="27" class="text-center"></v-img></a> -->

                                         <a :href="'tel:'+busines.agent.mobile" class="txtblck tvt"> <v-icon  >mdi-phone</v-icon></a>

                                  </v-col>

                                  <v-col cols="9" sm="4" md="4" class="text-center p-5">

                                      <div class="txt_color fs-15 lh-1">ACTIVE</div>
                                      <div class="fs-10">Last Logged In</div>
                                  </v-col>
                              </v-row>
                              <v-divider></v-divider>

                              <v-row align="center" justify="center" v-bind:class="{ 'd-flex': currentBusiness==busines.id,'d-none':currentBusiness!=busines.id }"  :id="busines.id">
                                  <v-col cols="4" sm="4" md="4" align="left" >

                                        <div class="agent-act">AGENT ACTIVITY</div>
                                        <div class="agent-act-sub">Agent</div>
                                        <div class="agent-act-sub">{{ busines.agent.firstName }} {{ busines.agent.lastName }}</div>

                                  </v-col>

                                  <v-col cols="4" sm="4" md="4" class="text-center p-5">

                                      <div class="fs-10">ACTIVED</div>
                                      <div class="fs-10">{{ busines.agentCreated }}</div>
                                  </v-col>
                                   <v-col cols="4" sm="4" md="4" class="text-center ">
                                     <div class="tag-assign-bottom"
                                      :style="{ backgroundImage: `url('${tagIMG} ')`, height:'100px' }"> {{ busines.tagsassigned }} </div>

                                  </v-col>
                              </v-row>


                            </v-card-text>
                        </v-card>

                        <v-card class="mb-2 blue-grey lighten-4 bu-maker" >

                        </v-card>

                    </v-card>
                </v-col>
    </v-row>


     <!-- Desktop View -->

      <v-row align="center" justify="center" class="d-none d-md-flex ">
                <v-col cols="12" sm="12" md="12">
                    <v-card class="pa-0" v-for="busines in businesses">

                            <v-card-text class="bu-maker pt-0 pb-0" @click="businessDesktopDetail(busines.id)" :data-id="busines.id" style="padding-left:12px !important;padding-right:12px !important;">
                              <v-row align="start" justify="center" class="align-stretch bdr">
                                  <v-col cols="12" sm="4" md="4" align="left" justify="left" class="pt-0">
                                      <v-row>
                                          <v-col cols="12" md="9" sm="9" class="">
                                              <div class="bsubtitle">{{ busines.btype }}</div>
                                              <div class="bsubtitle">{{ busines.businessName }}</div>
                                              <div class="txt_color">{{ busines.businessType  }}</div>
                                              <div class="sCity sAddress">{{ busines.addressLine1 }} {{ busines.addressLine2 }}</div>
                                              <div class="sCity">{{ busines.addressLine3  }} {{ busines.addressLine4 }} {{ busines.addressLine5 }} </div>
                                          </v-col>
                                          <v-col cols="12" md="3" sm="3" class="">
                                              <v-img :src="busines.logo" width="100" height="50" contain="true"></v-img>
                                          </v-col>
                                      </v-row>

                                  </v-col>

                                  <v-col cols="12" sm="3" md="3" class="text-center verticalLine">
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6" class="text-center pt-0">
                                            <!-- <div class="tag-assign" :style="{ backgroundImage: `url('${tagIMG} ')`,'background-size':'cover' , height:'110px'}">
                                            <v-img :src="contactIMG"  class="cut"></v-img>
                                             </div> -->

                                             <div class="" >
                                            <v-img :src="busines.contactimage" width="100" height="50" class="cut" contain="true"></v-img>
                                             </div>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6" class="text-center pt-0">
                                             <div class="bsubtitle">{{ busines.contactName }}</div>
                                             <div class="txt_color">{{ busines.contactPosition  }}</div>
                                             <div class="fs-10">Employees:{{ busines.employees }}</div>
                                        </v-col>
                                    </v-row>


                                  </v-col>

                                  <v-col cols="12" sm="3" md="3" class="text-center verticalLine">

                                      <v-row>
                                          <v-col cols="12" sm="12" md="12" class="text-center txt_color fs-15 pt-0">
                                            ACTIVITY
                                          </v-col>
                                      </v-row>

                                       <v-row>
                                          <v-col cols="6" sm="6" md="6" class="text-center pt-0">
                                            <div class="fs-10 ln-1">DATE CREATED :</div>
                                            <div class="fs-10">{{ busines.agentCreated }}</div>

                                            <div class="fs-10 ">LAST LOGIN :</div>
                                            <div class="fs-10"></div>
                                          </v-col>
                                          <v-col cols="6" sm="6" md="6" class="text-center pt-0">
                                            <div class="fs-10 ln-1">AGENT</div>
                                            <div class="fs-10">{{ busines.agent.firstName }} {{ busines.agent.lastName }}</div>

                                            <div class="fs-10 ">LAST VISIT</div>
                                            <div class="fs-10"></div>
                                          </v-col>
                                      </v-row>

                                  </v-col>

                                  <v-col cols="12" sm="2" md="2" class="text-center verticalLine">
                                    <v-row class="align-stretch">
                                      <v-col cols="6" sm="6" md="6" class="text-center pa-0">
                                         <!-- <a :href="'tel:'+busines.agent.mobile" class="txtblck"><v-icon  >{{ icon }}</v-icon></a> -->
                                         <a :href="'tel:'+busines.agent.mobile" class="txtblck"><v-icon  >fa-phone</v-icon></a>
                                      </v-col>
                                      <v-col cols="6" sm="6" md="6" class="text-center pa-0">
                                        <div class="tag-assign-dasktop d-img d-inline-block"
                                      :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ busines.tagsassigned }} </div>
                                      </v-col>


                                    </v-row>
                                    <!--  <v-row>
                                        <v-col cols="12" sm="12" md="12" class="text-center pa-0 pt-2">
                                          <v-btn @click="addFoodItem(busines.id)" color="primary "  fab x-small dark class="mr-0" title="Add Food Item">
                                            <v-icon>mdi-food</v-icon>
                                          </v-btn>
                                          <v-btn @click="addDrinkItem(busines.id)" color="primary "  fab x-small dark class="mr-0" title="Add Drink Item">
                                            <v-icon>mdi-glass-mug</v-icon>
                                          </v-btn>
                                          <v-btn @click="addEmployee(busines.id)" color="primary "  fab x-small dark class="mr-0" title="Add Employee">
                                            <v-icon>mdi-account-tie</v-icon>
                                          </v-btn>
                                          <v-btn @click="addDepartment(busines.id)" color="primary "  fab x-small dark class="mr-0" title="Add Department">
                                            <v-icon>mdi-desktop-mac</v-icon>
                                          </v-btn>
                                           <v-btn @click="addEvent(busines.id)" color="primary " fab x-small dark class="mr-0" title="Add Event">
                                            <v-icon>mdi-calendar-plus</v-icon>
                                          </v-btn>
                                          <v-btn @click="addbusiessdetail(busines.id)" color="primary "  fab x-small dark class="mr-0" title="Add Business Details">
                                            <v-icon>mdi-food</v-icon>
                                          </v-btn>
                                          <v-btn @click="editItem(busines.id)" color="primary " fab x-small dark class="mr-0">
                                            <v-icon>mdi-pencil</v-icon>
                                          </v-btn>
                                        </v-col>
                                    </v-row>-->

                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-btn @click="openbusiness(busines.id)" color="primary "   class="mr-0" >
                                              Go to Businesss
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                  </v-col>


                              </v-row>

                              <v-row v-bind:class="{ 'd-flex': currentBusiness==busines.id,'d-none':currentBusiness!=busines.id }"  :id="busines.id">

                                 <v-col cols="3" sm="3" md="3" align="left" justify="left" class="">
                                    <v-row>
                                       <v-col cols="12" sm="12" md="12" align="left" justify="left" v-if="busines.businessName" >

                                          <div class="bdr-bottom" >
                                            {{ busines.businessName }} </div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" >
                                            <div class="bdr-bottom" :v-if="busines.ownername!=''">{{ busines.ownername }}</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" class="" v-if="busines.ownerposition">
                                            <div class="bdr-bottom" > {{ busines.ownerposition }}</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" class="" v-if="busines.businessType">
                                            <div class="bdr-bottom" >{{ busines.businessType }}</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" class="" v-if="busines.addressLine1">
                                            <div class="bdr-bottom" >{{ busines.addressLine1 }}</div>
                                        </v-col>
                                         <v-col cols="12" sm="12" md="12" align="left" justify="left" class="" v-if="busines.addressLine2">
                                            <div class="bdr-bottom" >{{ busines.addressLine2 }}</div>
                                        </v-col>
                                         <v-col cols="12" sm="12" md="12" align="left" justify="left" class="" v-if="busines.addressLine3">
                                            <div class="bdr-bottom" >{{ busines.addressLine3 }}</div>
                                        </v-col>
                                         <v-col cols="12" sm="12" md="12" align="left" justify="left" class="" v-if="busines.addressLine4">
                                            <div class="bdr-bottom " > {{ busines.addressLine4 }}</div>
                                        </v-col>
                                    </v-row>
                                      <v-row>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left">
                                           <div class="customer">CUSTOMER</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" v-if="busines.contactName">
                                          <div class="bdr-bottom " >{{ busines.contactName }}</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" v-if="busines.contactPosition">
                                          <div class="bdr-bottom " >{{ busines.contactPosition }}</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" v-if="busines.contactPhone">
                                          <div class="bdr-bottom " >{{ busines.contactPhone }}</div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" align="left" justify="left" v-if="busines.contactEmail">
                                         <div class="bdr-bottom " > {{ busines.contactEmail }}</div>
                                        </v-col>

                                      </v-row>
                                 </v-col>

                                  <v-col cols="3" sm="3" md="3" align="left" justify="left" class="">
                                      <v-row>
                                          <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                            <!-- <v-img :src="headerIMG"></v-img> -->
                                             <v-img :src="busines.logo" width="128" height="128" contain="true"></v-img>
                                          </v-col>
                                      </v-row>
                                      <v-row>
                                         <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                           <v-icon  >mdi-cellphone</v-icon>
                                          </v-col>
                                          <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">

                                            <div class="bdr-bottom ">{{ busines.mobile }}</div>
                                          </v-col>
                                      </v-row>
                                      <v-row>
                                          <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                            <v-icon>mdi-phone-classic</v-icon>
                                          </v-col>
                                          <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">

                                           <div class="bdr-bottom "> {{ busines.phone }}</div>
                                          </v-col>
                                      </v-row>
                                      <v-row>
                                          <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                            <v-icon  >mdi-whatsapp </v-icon>
                                          </v-col>
                                          <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">

                                            <div class="bdr-bottom ">{{busines.whatsapp}}</div>
                                          </v-col>
                                      </v-row>
                                      <v-row>
                                          <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                            <v-icon >mdi-web</v-icon>
                                          </v-col>
                                          <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                            <div class="bdr-bottom ">{{ busines.website }}</div>
                                          </v-col>
                                      </v-row>
                                      <v-row v-for="socialmedia in busines.socialmedia">
                                        <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                            <v-icon  >{{socialmedia.social_media.icon}} </v-icon>
                                          </v-col>


                                          <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                            <div class="bdr-bottom ">{{ socialmedia.value }}</div>
                                          </v-col>
                                      </v-row>

                                      <v-row>
                                          <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                            <v-img :src="busines.contactimage" contain="true"></v-img>
                                          </v-col>
                                      </v-row>
                                  </v-col>

                                  <v-col  cols="6" sm="6" md="6" align="left" justify="left" class="">
                                    <!-- <v-row v-if="busines.allwaysopen">
                                      <v-col cols="12" sm="12" md="12">
                                        <h4>Always Open</h4>
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="!busines.allwaysopen">-->
                                    <v-row >
                                      <v-col cols="12" sm="12" md="12">
                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            MONDAY
                                          </v-col>



                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.mondayopening==null || busines.mondayopening=='null' || busines.mondayopening=='0') && (busines.mondayclosing==null || busines.mondayclosing=='null' || busines.mondayclosing=='0') && (busines.mondayopening2==null || busines.mondayopening2=='null' || busines.mondayopening2=='0') && (busines.mondayclosing2==null || busines.mondayclosing2=='null' || busines.mondayclosing2=='0'))"   >
                                            CLOSED
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.mondayopening=='allwaysopen') && (busines.mondayclosing=='allwaysopen') && (busines.mondayopening2=='allwaysopen') && (busines.mondayclosing2=='allwaysopen'))">
                                            Always Open
                                          </v-col>


                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>
                                            <span v-if="busines.mondayopening==0">Closed - </span>
                                            <span v-else>{{ busines.mondayopening }} - </span>
                                            <span v-if="busines.mondayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.mondayclosing }} - </span>
                                            <span v-if="busines.mondayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.mondayopening2 }} - </span>
                                            <span v-if="busines.mondayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.mondayclosing2 }}</span>

                                          </v-col>

                                        </v-row>

                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            TUESDAY
                                          </v-col>


                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.tuesdayopening==null || busines.tuesdayopening=='null' || busines.tuesdayopening=='0') && (busines.tuesdayclosing==null || busines.tuesdayclosing=='null' || busines.tuesdayclosing=='0') && (busines.tuesdayopening2==null || busines.tuesdayopening2=='null' || busines.tuesdayopening2=='0')&& (busines.tuesdayclosing2==null || busines.tuesdayclosing2=='null' || busines.tuesdayclosing2=='0'))"  >
                                            CLOSED
                                          </v-col>


                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.tuesdayopening=='allwaysopen' ) && (busines.tuesdayclosing=='allwaysopen') && (busines.tuesdayopening2=='allwaysopen') && (busines.tuesdayclosing2=='allwaysopen'))"  >
                                            Always Open
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>

                                            <span v-if="busines.tuesdayopening==0">Closed - </span>
                                            <span v-else>{{ busines.tuesdayopening }} - </span>
                                            <span v-if="busines.tuesdayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.tuesdayclosing }} - </span>
                                            <span v-if="busines.tuesdayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.tuesdayopening2 }} - </span>
                                            <span v-if="busines.tuesdayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.tuesdayclosing2 }}</span>


                                          </v-col>

                                        </v-row>

                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            WEDNESDAY
                                          </v-col>


                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.wednesdayopening=='allwaysopen') && (busines.wednesdayclosing=='allwaysopen') && (busines.wednesdayopening2=='allwaysopen') && (busines.wednesdayclosing2=='allwaysopen'))" >
                                            Always Open
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.wednesdayopening==null || busines.wednesdayopening=='null' || busines.wednesdayopening=='0') && (busines.wednesdayclosing==null || busines.wednesdayclosing=='null' || busines.wednesdayclosing=='0') && (busines.wednesdayopening2==null || busines.wednesdayopening2=='null' || busines.wednesdayopening2=='0') && (busines.wednesdayclosing2==null || busines.wednesdayclosing2=='null' || busines.wednesdayclosing2=='0'))" >
                                            CLOSED
                                          </v-col>
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>

                                            <span v-if="busines.wednesdayopening==0">Closed - </span>
                                            <span v-else>{{ busines.wednesdayopening }} - </span>
                                            <span v-if="busines.wednesdayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.wednesdayclosing }} - </span>
                                            <span v-if="busines.wednesdayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.wednesdayopening2 }} - </span>
                                            <span v-if="busines.wednesdayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.wednesdayclosing2 }}</span>




                                          </v-col>
                                        </v-row>

                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            THURSDAY
                                          </v-col>


                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.thursdayopening==null || busines.thursdayopening=='null' || busines.thursdayopening=='0') && (busines.thursdayclosing==null || busines.thursdayclosing=='null' || busines.thursdayclosing=='0') && (busines.thursdayopening2==null || busines.thursdayopening2=='null' || busines.thursdayopening2=='0') && (busines.thursdayclosing2==null || busines.thursdayclosing2=='null' || busines.thursdayclosing2=='0') )"  >
                                            CLOSED
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.thursdayopening=='allwaysopen') && (busines.thursdayclosing=='allwaysopen') && (busines.thursdayopening2=='allwaysopen') && (busines.thursdayclosing2=='allwaysopen') )"  >
                                            Always Open
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>
                                            <span v-if="busines.thursdayopening==0">Closed - </span>
                                            <span v-else>{{ busines.thursdayopening }} - </span>
                                            <span v-if="busines.thursdayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.thursdayclosing }} - </span>
                                            <span v-if="busines.thursdayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.thursdayopening2 }} - </span>
                                            <span v-if="busines.thursdayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.thursdayclosing2 }}</span>


                                          </v-col>


                                        </v-row>

                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            FRIDAY
                                          </v-col>

                                          <!-- <v-col cols="1" sm="1" md="1" align="left" justify="left" class="day" v-if="((busines.fridayopening==null || busines.fridayopening=='null' || busines.fridayopening=='0') && (busines.fridayclosing==null || busines.fridayclosing=='null' || busines.fridayclosing=='0'))">
                                            <v-icon :color="colorred">mdi-toggle-switch-off</v-icon>
                                          </v-col>

                                          <v-col v-else cols="1" sm="1" md="1" align="left" justify="left" class="day" >
                                            <v-icon :color="colorgreen">mdi-toggle-switch</v-icon>
                                          </v-col>


                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.fridayopening==null || busines.fridayopening=='null' || busines.fridayopening=='0') && (busines.fridayclosing==null || busines.fridayclosing=='null' || busines.fridayclosing=='0'))" >
                                            CLOSED
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>
                                            {{ busines.fridayopening }} - {{ busines.fridayclosing }}
                                          </v-col> -->

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.fridayopening==null || busines.fridayopening=='null' || busines.fridayopening=='0') && (busines.fridayclosing==null || busines.fridayclosing=='null' || busines.fridayclosing=='0') && (busines.fridayopening2==null || busines.fridayopening2=='null' || busines.fridayopening2=='0') && (busines.fridayclosing2==null || busines.fridayclosing2=='null' || busines.fridayclosing2=='0'))" >
                                            CLOSED
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.fridayopening=='allwaysopen') && (busines.fridayclosing=='allwaysopen') && (busines.fridayopening2=='allwaysopen') && (busines.fridayclosing2=='allwaysopen'))" >
                                            Always Open
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>
                                            <span v-if="busines.fridayopening==0">Closed - </span>
                                            <span v-else>{{ busines.fridayopening }} - </span>
                                            <span v-if="busines.fridayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.fridayclosing }} - </span>
                                            <span v-if="busines.fridayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.fridayopening2 }} - </span>
                                            <span v-if="busines.fridayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.fridayclosing2 }}</span>


                                          </v-col>


                                        </v-row>

                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            SATURDAY
                                          </v-col>

                                          <!-- <v-col cols="1" sm="1" md="1" align="left" justify="left" class="day" v-if="((busines.saturdayopening==null || busines.saturdayopening=='null' || busines.saturdayopening=='0') && (busines.saturdayclosing==null || busines.saturdayclosing=='null' || busines.saturdayclosing=='0'))">
                                            <v-icon :color="colorred">mdi-toggle-switch-off</v-icon>
                                          </v-col>

                                          <v-col cols="1" sm="1" md="1" align="left" justify="left" class="day" v-else>
                                            <v-icon :color="colorgreen">mdi-toggle-switch</v-icon>
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.saturdayopening==null || busines.saturdayopening=='null' || busines.saturdayopening=='0') && (busines.saturdayclosing==null || busines.saturdayclosing=='null' || busines.saturdayclosing=='0'))" >
                                            CLOSED
                                          </v-col>
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>
                                            {{ busines.saturdayopening }} - {{ busines.saturdayclosing }}
                                          </v-col> -->
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.saturdayopening==null || busines.saturdayopening=='null' || busines.saturdayopening=='0') && (busines.saturdayclosing==null || busines.saturdayclosing=='null' || busines.saturdayclosing=='0') && (busines.saturdayopening2==null || busines.saturdayopening2=='null' || busines.saturdayopening2=='0') && (busines.saturdayclosing2==null || busines.saturdayclosing2=='null' || busines.saturdayclosing2=='0') )" >
                                            CLOSED
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.saturdayopening=='allwaysopen' ) && (busines.saturdayclosing=='allwaysopen') && (busines.saturdayopening2=='allwaysopen') && (busines.saturdayclosing2=='allwaysopen') )" >
                                            Always Open
                                          </v-col>

                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>

                                            <span v-if="busines.saturdayopening==0">Closed - </span>
                                            <span v-else>{{ busines.saturdayopening }} - </span>
                                            <span v-if="busines.saturdayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.saturdayclosing }} - </span>
                                            <span v-if="busines.saturdayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.saturdayopening2 }} - </span>
                                            <span v-if="busines.saturdayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.saturdayclosing2 }}</span>


                                          </v-col>
                                        </v-row>

                                        <v-row>
                                          <v-col cols="4" sm="4" md="4" align="left" justify="left" class="day">
                                            SUNDAY
                                          </v-col>

                                          <!-- <v-col cols="1" sm="1" md="1" align="left" justify="left" class="day" v-if="((busines.sundayopening==null || busines.sundayopening=='null' || busines.sundayopening=='0') && (busines.sundayclosing==null || busines.sundayclosing=='null' || busines.sundayclosing=='0'))">
                                          <v-icon :color="colorred">mdi-toggle-switch-off</v-icon>
                                          </v-col>

                                          <v-col  cols="1" sm="1" md="1" align="left" justify="left" class="day" v-else>
                                            <v-icon :color="colorgreen">mdi-toggle-switch</v-icon>
                                          </v-col>





                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.sundayopening==null || busines.sundayopening=='null' || busines.sundayopening=='0') && (busines.sundayclosing==null || busines.sundayclosing=='null' || busines.sundayclosing=='0'))">

                                            CLOSED

                                          </v-col>
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>

                                            {{ busines.sundayopening }} - {{ busines.sundayclosing }}

                                          </v-col> -->
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-if="((busines.sundayopening==null || busines.sundayopening=='null' || busines.sundayopening=='0') && (busines.sundayclosing==null || busines.sundayclosing=='null' || busines.sundayclosing=='0') && (busines.sundayopening2==null || busines.sundayopening2=='null' || busines.sundayopening2=='0') && (busines.sundayclosing2==null || busines.sundayclosing2=='null' || busines.sundayclosing2=='0'))">

                                            CLOSED

                                          </v-col>
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else-if="((busines.sundayopening=='allwaysopen') && (busines.sundayclosing=='allwaysopen' ) && (busines.sundayopening2=='allwaysopen') && (busines.sundayclosing2=='allwaysopen' ))">

                                            Allways Open

                                          </v-col>
                                          <v-col cols="6" sm="6" md="6" align="left" justify="left" class="day" v-else>

                                            <span v-if="busines.sundayopening==0">Closed - </span>
                                            <span v-else>{{ busines.sundayopening }} - </span>
                                            <span v-if="busines.sundayclosing==0">Closed - </span>
                                            <span v-else>{{ busines.sundayclosing }} - </span>
                                            <span v-if="busines.sundayopening2==0">Closed - </span>
                                            <span v-else>{{ busines.sundayopening2 }} - </span>
                                            <span v-if="busines.sundayclosing2==0">Closed</span>
                                            <span v-else>{{ busines.sundayclosing2 }}</span>

                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                    <v-row >
                                      <v-col cols="12" sm="12" md="12">
                                        {{busines.openinghoursother}}
                                      </v-col>
                                    </v-row>

                                  </v-col>

                              </v-row>

                            </v-card-text>


                        <v-card class="mb-2 blue-grey lighten-4 bu-maker" >

                        </v-card>

                    </v-card>
                </v-col>
     </v-row>



  </v-container>
</template>

<script>
import moment from 'moment';
export default
{
    data: () => ({
      overlay: true,
      colorgreen:'green',
      colorred:'red',
      search: "",
      bottomIMG:require("@/assets/Mask.png"),
      headerIMG:require("@/assets/Matrix-Header-Logo.png"),
      openImg:require("@/assets/open.png"),
      closeImg:require("@/assets/close.png"),
      phoneImg:require("@/assets/phone.png"),
      landlineImg:require("@/assets/landline.png"),
      whatsappImg:require("@/assets/whatsaap.png"),
      websiteImg:require("@/assets/website.png"),
      fbImg:require("@/assets/fb-icon.png"),
      tripImg:require("@/assets/trip.png"),
      instagramImg:require("@/assets/instagra.png"),
      twitterImg:require("@/assets/twitter.png"),
      newMsg:require("@/assets/new_message.png"),
      tagIMG:require("@/assets/Rectangle4.png"),
      phoneIMG:require("@/assets/Vector.png"),
      contactIMG:require("@/assets/Andrew.png"),
      bid:"",
      currentBusiness:0,
      color:"",
      businesses: []

    }),
    created() {

      this.$http
        .get(this.$apidomain+"agent/businesslist")
        .then(res => {
          this.businesses = res.data.businesses;
          this.overlay=false;
        })
        .catch(err => {
          console.log(err.response);
          this.overlay=false;
        });

    },
    methods: {
      addEvent(id)
      {
        this.$router.push({name:'eventlist',params:{business_id:id}});
      },
      addDrinkItem(id)
      {
        this.$router.push({name:'drinkitemlist',params:{business_id:id}});
      },
      addDepartment(id)
      {
        this.$router.push({name:'departmentlist',params:{business_id:id}});
      },
      addEmployee(id)
      {
        this.$router.push({name:'employeelist',params:{business_id:id}});
      },
      addFoodItem(id){
          //this.$router.push({name:'createitem',params:{business_id:id}});
          this.$router.push({name:'itemlist',params:{business_id:id}});
      },

      addbusiessdetail(id)
      {
        this.$router.push({name:'createbusinessdetail',params:{business_id:id}});
      },
      editItem(item)
      {
        this.$router.push({name:'editbusiness',params:{id:item}});
      },
      openbusiness(bid)
      {

          this.$http
          .post(this.$apidomain+"loginuserbyagent",{businessid:bid})
          .then(res =>
          {

            if(res.data.success)
            {

              localStorage.removeItem('business');

              localStorage.setItem('business',JSON.stringify(res.data.business));
              //commit('storeBussiness',JSON.stringify(res.data.business));



              //  if(res.data.user.userType=='business')
              // {

              //   localStorage.setItem('business',JSON.stringify(res.data.user.business));
              //   commit('storeBussiness',JSON.stringify(res.data.user.business));
              // }
              // else{
              //   localStorage.removeItem('business');
              //   //Vue.prototype.$user=new Object;
              // }
              // localStorage.setItem('isLoggedin','true');
              // commit('auth_success',JSON.stringify(res.data.user));


               //this.$router.push({name:'dashboardbusiness'});
               let routeData = this.$router.resolve({name:'businessstatics'});
               window.open(routeData.href, '_blank');

            }
            // this.businesses = res.data.businesses;
            // this.overlay=false;
          })
          .catch(err => {
            console.log(err.response);

          });

      },
     bDetail(id)
      {
        if(this.currentBusiness==0)
        {
          this.currentBusiness=id;
        }else{
          this.currentBusiness=0;
        }



      },

       businessDesktopDetail(id){
        if(this.currentBusiness==0)
        {
          this.currentBusiness=id;
        }else{
          this.currentBusiness=0;
        }
      },

      createagent(){
          this.$router.push('/createbusiness');
      }
    }
};
</script>

<style>
.ml-20{
  margin-left: 20px !important;
}
.bdr{
  border:1px solid #c2c2c2;
  box-shadow: 3px 3px #c2c2c2;
  border-radius:4px;
}
.pr-5{
  padding-right: 5px ;
}
.d-img{
  display: inline-block !important;
  width: 65px;
  height: 65px;
  line-height: 65px;
}
.day{
  font-size: 15px;

}
.cut{
    -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

}
.ln-1{
  line-height: 1px;
}
.fs-15{
  font-size: 15px;
}
.agent-act-sub{
  font-size:10px;
}
.agent-act{
  font-size:12px;
  font-weight: bold;
  color: #928d8d;
  line-height: 1rem;
}
.lh-1{
  line-height: 1rem;
}
.fs-10{
  font-size: 10px;
}
.sort{
    font-size:12px;
}
.pt-0{
    padding-top: 0px;
}
.pb-0{
    padding-bottom: 0px;
}
.btitle{
    font-size: 30px;
    color: #ff5800 !important;
    font-weight: bold;
    text-align: center !important;
    line-height: 1rem;
}
.bsubtitle{
  line-height: 1rem;
  font-weight: bold;
  font-size:18px;
}
.txt_color{
    color: #ff5800 !important;
}
.customer{
  color: #ff5800 !important;
  font-size: 15px;
  font-weight: bold;
}
.m-5{
    margin: 5px;
}
.text-center{
    text-align: center !important;
}
.verticalLine {
  border-left: 1px solid #928d8d;
}
.mb-2{
    margin-bottom: 2px;
}
.p-5{
    padding: 5px;
}
.sCity{
  font-size: 12px;
}
.sAddress{
  line-height: 0.5rem;
}
.tag-assign{
  font-size: 20px;
  /* background-size:cover; */
  padding: 24px;
  padding-left: 10px;
  margin-left: 20px;
  color: #c9c9c9;

}
.tag-assign-bottom{
  font-size: 20px;
  /* background-size:cover; */
  padding: 24px;
  padding-left: 23px;
  margin-left: 20px;
  color: #c9c9c9;
}
.tag-assign-dasktop{
  /* padding: 20px 25px !important; */

  font-size: 16px;
  background-size: cover;
  background-position: top center;
  color: #c9c9c9;
}
.fs-15{
  font-size: 15px;
  font-weight: bold;
}
.bdr-bottom
{
  border-bottom: 1px solid #c2c2c2
}
</style>
